/** Where a queued job's Assign button goes (gitaumoses4/chukua#55). A trip is `pending` until a crew is assigned, so "no crew" is that status. */
export type BoardAssignTarget = { kind: 'assign-trip'; tripId: string } | { kind: 'job-trips'; label: 'Plan trips' | 'Choose trip' };

/** Exactly one trip waiting for a crew is unambiguous and goes straight to the picker; none means the job still needs trips, several means the dispatcher picks one. */
export function boardAssignTarget(trips: readonly { id: string; status: string }[]): BoardAssignTarget {
  const waitingForCrew = trips.filter((trip) => trip.status === 'pending');
  if (waitingForCrew.length === 1) return { kind: 'assign-trip', tripId: waitingForCrew[0].id };
  return { kind: 'job-trips', label: waitingForCrew.length === 0 ? 'Plan trips' : 'Choose trip' };
}
